import React from "react";
import {
  StyledDataWritingNote,
  StyledDeleteNote,
  StyledNoteBody,
  StyledNoteComponent,
} from "./NoteItem.styled";
import { BodyTyp } from "../../../../../../components/Typography/Typography";
import { TextAreaBox } from "../../../../../../components/TextAreaBox/TextAreaBox";
import {
  FontWeightEnum,
  IconSizeEnum,
  Role,
} from "../../../../../../types/AppTypes";
import { IconManager } from "../../../../../../components/core/IconManager/IconManager";
import { ReactComponent as BinIcon } from "../../../../../../icons/bin.svg";
import { DELETE_NOTE_LABEL } from "../../../../../../constants/Dictionary";
import {
  Avatar,
  AvatarDimensionsEnum,
} from "../../../../../../components/core/Avatar/Avatar";
import { useAppSelector } from "../../../../../../hooks/store.hook";
import dayjs from "dayjs";
import { getInitials } from "../../../../../../utils/collaborators.utils";
import { findLabelRoleByValue } from "../../../../../../utils/orgFunctions.utils";

type NoteItemProps = {
  id: number;
  name: string;
  surname: string;
  role: Role;
  date: Date | string;
  onDelete: (x: number) => void;
  note: string;
  collaboratorId: number;
};

export const NoteItem = ({
  id,
  name,
  surname,
  role,
  date,
  note,
  onDelete,
  collaboratorId,
}: NoteItemProps) => {
  const { profile } = useAppSelector((state) => state.user);
  const { orgSettings } = useAppSelector((state) => state.config);

  const isCollaborator = profile.id === collaboratorId;

  return (
    <StyledNoteComponent>
      <div>
        <Avatar
          variant={AvatarDimensionsEnum.SMALL}
          collaboratorId={collaboratorId}
          initials={getInitials(name, surname)}
        />
      </div>
      <StyledNoteBody>
        <StyledDataWritingNote>
          <div>
            <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
              {surname} {name}
            </BodyTyp>
            <BodyTyp variant="2" fontWeight={FontWeightEnum.REGULAR}>
              {findLabelRoleByValue(orgSettings.userRoles, role)}
            </BodyTyp>
          </div>
          <BodyTyp variant="2" fontWeight={FontWeightEnum.REGULAR}>
            {dayjs(date).format("DD.MM.YYYY")}
          </BodyTyp>
        </StyledDataWritingNote>
        <TextAreaBox text={note} />
      </StyledNoteBody>
      {isCollaborator && (
        <StyledDeleteNote
          onClick={() => {
            onDelete(id);
          }}
        >
          <IconManager size={IconSizeEnum.SMALL}>
            <BinIcon />
          </IconManager>
          <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
            {DELETE_NOTE_LABEL}
          </BodyTyp>
        </StyledDeleteNote>
      )}
    </StyledNoteComponent>
  );
};
